var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("StatusBar", { attrs: { params: this.$route.query.params } }),
      _vm.personList.length > 0
        ? _c(
            "div",
            { staticClass: "tool-list" },
            [
              _c("span", { staticClass: "mr-2" }, [
                _vm._v("共計：" + _vm._s(_vm.totalPerson) + "人"),
              ]),
              _c("CardStyle", { on: { changeStyle: _vm.changeStyle } }),
            ],
            1
          )
        : _vm._e(),
      _c("SearchBar", {
        attrs: { show: _vm.showSearchBar },
        on: {
          showSearchBar: function ($event) {
            _vm.showSearchBar = !_vm.showSearchBar
          },
          search: function ($event) {
            ;(_vm.currentPage = 1), _vm.getInterviewResult()
          },
        },
        scopedSlots: _vm._u([
          {
            key: "searchItem",
            fn: function () {
              return [
                _c("el-input", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    clearable: "",
                    placeholder: "關鍵字（姓名、Email、聯絡電話）",
                  },
                  model: {
                    value: _vm.searchCondition.Keyword,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.searchCondition,
                        "Keyword",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "searchCondition.Keyword",
                  },
                }),
                _c("el-date-picker", {
                  staticClass: "w-100 item-bottom",
                  attrs: {
                    type: "daterange",
                    clearable: "",
                    "picker-options": {
                      disabledDate: _vm.$common.disabledDateAfterToday,
                    },
                    "range-separator": "-",
                    "start-placeholder": "面談日期(起)",
                    "end-placeholder": "面談日期(迄)",
                  },
                  model: {
                    value: _vm.searchCondition.InterviewDateRange,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchCondition, "InterviewDateRange", $$v)
                    },
                    expression: "searchCondition.InterviewDateRange",
                  },
                }),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "單位面試主管",
                    },
                    model: {
                      value: _vm.searchCondition.InterviewSupervisor,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchCondition,
                          "InterviewSupervisor",
                          $$v
                        )
                      },
                      expression: "searchCondition.InterviewSupervisor",
                    },
                  },
                  _vm._l(_vm.supervisorOptions, function (supervisor) {
                    return _c("el-option", {
                      key: supervisor.Guid,
                      attrs: { label: supervisor.Name, value: supervisor.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: "HR 面試人員",
                    },
                    model: {
                      value: _vm.searchCondition.InterviewHR,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "InterviewHR", $$v)
                      },
                      expression: "searchCondition.InterviewHR",
                    },
                  },
                  _vm._l(_vm.supervisorOptions, function (supervisor) {
                    return _c("el-option", {
                      key: supervisor.Guid,
                      attrs: { label: supervisor.Name, value: supervisor.Name },
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: {
                      multiple: "",
                      clearable: "",
                      placeholder: "應聘者狀態",
                    },
                    model: {
                      value: _vm.searchCondition.Status,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "Status", $$v)
                      },
                      expression: "searchCondition.Status",
                    },
                  },
                  [
                    _c("el-option", {
                      attrs: { label: "錄取", value: "錄取" },
                    }),
                    _c("el-option", {
                      attrs: { label: "考慮中", value: "考慮中" },
                    }),
                    _c("el-option", {
                      attrs: { label: "複試", value: "複試" },
                    }),
                    _c("el-option", {
                      attrs: { label: "不錄取", value: "不錄取" },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "w-100 item-bottom",
                    attrs: { clearable: "", placeholder: "是否已發送感謝函" },
                    model: {
                      value: _vm.searchCondition.IsSendThanksMail,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchCondition, "IsSendThanksMail", $$v)
                      },
                      expression: "searchCondition.IsSendThanksMail",
                    },
                  },
                  [
                    _c("el-option", { attrs: { label: "是", value: true } }),
                    _c("el-option", { attrs: { label: "否", value: false } }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ActionBar", {
        attrs: {
          show: _vm.showActionBar,
          totalPerson: _vm.totalPerson,
          selectedCardList: _vm.choosePersonList,
        },
        on: {
          showActionBar: function ($event) {
            _vm.showActionBar = !_vm.showActionBar
          },
          selectAllCards: _vm.selectAllCards,
          clearSelectCard: _vm.clearSelectCard,
        },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.sendThanksMail()
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "email-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("批次發送感謝函")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "person-card-list",
          class: {
            "list-style": _vm.gridStyle == "list",
            "block-style": _vm.gridStyle == "block",
          },
        },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            { key: index, staticClass: "person-card infinite-list-item" },
            [
              _c("PersonCard", {
                ref: "personCard",
                refInFor: true,
                attrs: { showCheckbox: true, person: person },
                on: { updatePersonList: _vm.updatePersonList },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "note",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.clickResumeNote(props)
                                },
                              },
                            },
                            [
                              _c("eva-icon", {
                                attrs: {
                                  name: "color-picker-outline",
                                  fill: "#000",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: "tag",
                      fn: function ({ props }) {
                        return [
                          _c("div", { staticClass: "result" }, [
                            _vm._v(_vm._s(props.ApprovalResult)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "middleContent",
                      fn: function ({ props }) {
                        return [
                          _c("table", [
                            _c("tr", [
                              _c("th", [_vm._v("應徵職務")]),
                              _c("td", [_vm._v(_vm._s(props.Position))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("面談日期")]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$common.dateFormatter(
                                      props.InterviewDate
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("單位面試主管")]),
                              _c("td", [
                                _vm._v(_vm._s(props.InterviewSupervisor[0])),
                              ]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("HR 面試人員")]),
                              _c("td", [_vm._v(_vm._s(props.InterviewHR[0]))]),
                            ]),
                            _c("tr", [
                              _c("th", [_vm._v("是否發過感謝函")]),
                              _c("td", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      props.SendThankNoticeTime === null
                                        ? "否"
                                        : "是"
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "buttonGroup",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "el-dropdown",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "el-dropdown-link",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(" 檢視資訊"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showDetailModal(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視履歷 ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showProgressRecord(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視歷程 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          props.ApprovalResult === "錄取" ||
                          props.ApprovalResult === "考慮中"
                            ? _c(
                                "button",
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.createAppointmentForm(props)
                                    },
                                  },
                                },
                                [_vm._v(" 起任用單 ")]
                              )
                            : _vm._e(),
                          props.ApprovalResult === "不錄取"
                            ? [
                                props.SendThankNoticeTime === null
                                  ? _c(
                                      "button",
                                      {
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.sendThanksMail(props)
                                          },
                                        },
                                      },
                                      [_vm._v(" 發感謝函 ")]
                                    )
                                  : _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "light",
                                          content: "已發過感謝函",
                                          placement: "right",
                                        },
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.sendThanksMail(props)
                                              },
                                            },
                                          },
                                          [_vm._v(" 發感謝函 ")]
                                        ),
                                      ]
                                    ),
                              ]
                            : _vm._e(),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.getApproveInterview(props)
                                },
                              },
                            },
                            [_vm._v(" 面談評估 ")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.personList.length > 0
        ? _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.totalPerson,
              "page-size": 9,
            },
            on: { "current-change": _vm.changePage },
          })
        : _vm._e(),
      _c("ResumeNoteModal", { attrs: { personData: _vm.personData } }),
      _c("ThanksMailModal", {
        attrs: { personData: _vm.personData },
        on: {
          clearSelectCard: _vm.clearSelectCard,
          getLatestSearchResult: _vm.getInterviewResult,
        },
      }),
      _c("EvaluateInterviewModal", {
        attrs: {
          Source: "InterviewResult",
          AdmitOptions: _vm.admitOptions,
          IdlRejectOptions: _vm.idlRejectOptions,
          DlRejectOptions: _vm.dlRejectOptions,
          Person: _vm.personData,
        },
        on: { saveApproveInterview: _vm.saveApproveInterview },
      }),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 0
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.detailCurrentPage = 1
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: {
                                name: "message-circle-outline",
                                fill: "#FFF",
                              },
                            }),
                            _vm._v(" 面談紀錄 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("履歷")]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "item text-right" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$common.downloadResumePDF(
                                                      _vm.ResumeType,
                                                      _vm.ResumeId
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 下載 PDF ")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 1
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title" },
                                      [
                                        _c("Logo", { staticClass: "item" }),
                                        _c(
                                          "div",
                                          { staticClass: "item text-center" },
                                          [_vm._v("面談紀錄")]
                                        ),
                                        _c("div", { staticClass: "item" }),
                                      ],
                                      1
                                    ),
                                    _c("InterviewRecord", {
                                      attrs: { MatchId: _vm.MatchId },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("ProgressRecordModal", {
        attrs: { Name: _vm.Name, UserId: _vm.UserId, Email: _vm.Email },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }